import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { InvoiceModel } from './invoice.model';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'Invoice';
@Injectable({ providedIn: 'root' })
export class InvoiceDataService extends EfaactDataService<InvoiceModel> {
    mapItems(item: InvoiceModel): InvoiceModel {
        return {
            ...item,
            id: `${item.listid}-${item.InvoiceNbr}`
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
